// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__vTDQF","user-image":"Comment_user-image__+P5a+","comment-details":"Comment_comment-details__VJLDS","reply-button":"Comment_reply-button__7eRFN"};